import { render, staticRenderFns } from "./XPopover.vue?vue&type=template&id=751269c4&scoped=true"
import script from "./XPopover.vue?vue&type=script&lang=js"
export * from "./XPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751269c4",
  null
  
)

export default component.exports